import { render, staticRenderFns } from "./SbolListAnnotations.vue?vue&type=template&id=8b316328&scoped=true&"
import script from "./SbolListAnnotations.vue?vue&type=script&lang=js&"
export * from "./SbolListAnnotations.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolListAnnotations.vue?vue&type=style&index=0&id=8b316328&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8b316328",
  null
  ,true
)

export default component.exports